import { combineReducers } from 'redux';
import deviceData from './device_data';
import products from './products';
import items from './items';
import permissions from './permissions';
import videoupload from './video_upload';
import videoLibrary from './videoLibrary';
import session from './session';
import uom from './uom';
import toastMessage from './toastmessage';
import bulkUpload from './bulkUpload';
import libraryReducer from 'jd-library/libraryReducer';
import uploadOptions from './uploadOptions';
import showLoader from './loader';
import dashboard from './dashboard';
import contractor from './contractor';
import photosGallery from './photosGallery';
import userSettingsReducer from 'jd-library/userSettingsReducer';
import notificationCount from 'jd-library/notificationCountReducer';
import brandCategory from 'jd-library/brandCategoryReducer';
import productSpecification from './productSpecificationReducer';
import brandManufacturer from './brandManufacturesReducer'
import { productInventoryReducer } from './productInventory';
import hybrid from './hybridReducer';
import discount from './discount';
import addEditDiscount from './addEditDiscount';
import auditEnrichInfo from './auditEnrichReducer';
import variants from './variantsReducer';
import orderReturnInfo from './orderReturnReducer';
import orderListing from './orderListingReducer';
import barcodeScanner from './barcodeReducer';
import deliveryOptions from './deliveryOptions';
import deliveryBoyReducer from "./deliveryBoyReducer";
import jdCategoryList from './jdCategoryCover';
import notifications from "../pages/listing/Notifications/redux/reducer";
import feedback from "../common/Feature/FeedbackSlider/redux/reducer";
import supplierInfo from './supplierReducer';

//for individual package access on import
export const productCRUDReducers = {
	session,
	items,
	products,
	permissions,
	deviceData,
	uom,
	discount,
	addEditDiscount,
	supplierInfo
}

export const brandCatReducer = {
	brandCategory
}

export const bulkUploadReducer = {
	bulkUpload
}

export default combineReducers({
	...productCRUDReducers,
	...brandCatReducer,
	...bulkUploadReducer,
	deviceData,
	products,
	permissions,
	session,
	videoupload,
	uom,
	toastMessage,
	showLoader,
	//bulkUpload,
	library: libraryReducer,
	photosGallery,
	videoLibrary,
	uploadOptions,
	dashboard,
	userSettings:userSettingsReducer,
	notificationCount,
	contractor,
	productSpecification,
	brandManufacturer,
	productInventory: productInventoryReducer,
	variants,
	orderReturnInfo,
	auditEnrichInfo,
	orderListing,
	barcodeScanner,
	hybrid,
	deliveryOptions,
	deliveryBoy : deliveryBoyReducer,
	jdCategoryList,
	notifications,
	feedback,
	supplierInfo
});
